import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { selectUserProfileStatus } from '../../app/store/profileSlice';

const RequireProfile = (): JSX.Element => {
  const profileStatus = useSelector(selectUserProfileStatus);
  const location = useLocation();

  return profileStatus && profileStatus === 2 ? (
    <Outlet />
  ) : (
    <Navigate to={'/profile'} state={{ from: location }} replace />
  );
};

export default RequireProfile;
